// extracted by mini-css-extract-plugin
export default {"PasswordInput":"styles_PasswordInput__aoC0R","label":"styles_label__srbUX","input":"styles_input__uHLGf","passwordButton":"styles_passwordButton__6aFEu"};